import React from 'react'

const PingleFooter = () => {

    return (
        <>
            <div className="mb-5">
                <div className="p-3">
                    <h4 className="secondary-text-1 fs-30 ff-poppins-bold">Life romba busy ah?</h4>
                    <h4 className="secondary-text-1 fs-30 ff-poppins-bold">Pingle pannu easy ah! </h4>
                    <span className="ff-poppins-regular fs-13 secondary-text-1"> Built for Bharath, with ❤️ from Coimbatore!</span>
                </div>
            </div>
        </>
    );
}
export default PingleFooter;